<div class="mx-auto max-w-xl px-4 py-16 text-center">
  <p class="text-6xl font-bold text-emerald-600">404</p>
  <h1 class="mt-3 text-xl font-bold text-slate-900">Không tìm thấy trang</h1>
  <p class="mt-2 text-sm text-slate-600">Trang bạn tìm không tồn tại hoặc đã được chuyển đi.</p>
  <a routerLink="/" class="btn-primary mt-6">Về trang chủ</a>
</div>
